import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Tooltip } from 'antd';

const { Text } = Typography;

const VersionInfo = () => {
  const [version, setVersion] = useState('');
  const [buildTime, setBuildTime] = useState('');

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await axios.get(`${process.env.PUBLIC_URL}/version.json?_t=${timestamp}`);
        setVersion(response.data.version);
        setBuildTime(response.data.buildTime);
      } catch (error) {
        console.error('获取版本信息失败:', error);
      }
    };

    fetchVersion();
  }, []);

  if (!version) return null;

  return (
    <div style={{ position: 'fixed', bottom: '5px', right: '10px', fontSize: '12px', opacity: 0.7 }}>
      <Tooltip title={`构建时间: ${new Date(buildTime).toLocaleString()}`}>
        <Text type="secondary">v{version}</Text>
      </Tooltip>
    </div>
  );
};

export default VersionInfo; 